export default {
  keyword: 'Palabra clave',
  location: 'Ubicación',
  search: 'Buscar',
  jobs: 'Ofertas',
  searchJobs: 'Buscar ofertas',
  postAJob: 'ANUNCIAR UNA OFERTA',
  exploreCompanies: 'Explorar empresas',
  companies: 'Empresas',
  createCompany: 'CREAR UNA EMPRESA',
  browseTalent: 'Buscar talento',
  talent: 'Talento',
  joinTalentPool: 'ÚNASE AL GRUPO DE TALENTOS',
  loadMore: 'Cargar más',
  negotiable: 'Negociable',
  contract: 'Contrato',
  permanent: 'Permanente',
  remote: 'Remoto',
  percentOfSalary: '% del salario',
  rewardInCrypto: 'Recompensa en Crypto',
  rewardInUSD: 'Recompensa in USD',
  applyOrRefer: 'Solicita o remite a alguien a este trabajo para ganar recompensas en BTC, STX o Vibes',
  freeDonation: 'Donación gratuita',
  everySuccessfulHire: 'Cada contratación exitosa crea una donación gratis para la caridad, desde Hire Vibes.',
  viewJobsAndCompany: 'Ver ofertas y información de la impresa',
  salaryMin: 'Salario (min)',
  undisclosed: 'No revelado',
  noticePeriod: 'Plazo de preaviso',
  available: 'Disponible',
  permanentAndContract: 'Permanente/Contrato',
  engineering: 'Ingeniería',
  allJobs: 'Todos los trabajos',
  allEmploymentTypes: 'Todos los contratos',
  allSalaries: 'Todos los salarios',
  optIn: 'Inscríbete para que te tengan en cuenta para otros puestos de trabajo en esta red de empresas',
  firstName: 'Nombre',
  lastName: 'Apellido',
  attachCv: 'Adjuntar CV',
  apply: 'Solicitar',
  referSome: 'Recomienda a alguien',
  applicants: 'solicitantes'.toUpperCase(),
  openJobs: 'Ofertas abiertas'.toUpperCase(),
  noJobs: 'NO TRABAJOS',
  thereNoJObs: 'no hay trabajos',
  thisJobsJob: 'Este panel de empleos funciona con HireVibes.\n' +
    'Para anunciar una oferta, será dirigido a app.hirevibes.com\n',
  thisJobsCompany: 'Este panel de empleos funciona con HireVibes.\n' +
    'Para crear tu empresa, será dirigido a app.hirevibes.com\n',
  thisJobsTalent: 'Este panel de empleos funciona con HireVibes.\n' +
    'Para unirse a este grupo de talentos, será dirigido a app.hirevibes.com\n'
}
// this.$t('widget.noJobsDesc')



// WEBPACK FOOTER //
// ./src/i18n/es/widget.js